<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Carga de archivos</h4>
    <hr>
    <div class="container">
      <table width="100%">
        <tr>
          <td width="50%">
      <label for="file" class="file-label">Archivo:</label>
      <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" class="file-input"/>
          </td>
          <td width="50%">
      <select v-model="selectedFileType" class="styled-select" v-if="opcion===1">
        <option value="">Selecciona el tipo de archivo</option>
        <option value="AccesoSesion">AccesoSesion</option>
        <option value="Actividad">Actividad</option>
        <option value="Activo">Activo</option>
        <option value="Area">Area</option>
        <option value="Asiento">Asiento</option>
        <option value="AsientoAud">AsientoAud</option>
        <option value="Asistencia">Asistencia</option>
        <option value="Auto">Auto</option>
        <option value="Banco">Banco</option>
        <option value="Bitacora">Bitacora</option>
        <option value="Cargo">Cargo</option>
        <option value="CargoPers">CargoPers</option>
        <option value="Carroceria">Carroceria</option>
        <option value="CentroPre">CentroPre</option>
        <option value="Cita">Cita</option>
        <option value="Color">Color</option>
        <option value="Combustible">Combustible</option>
        <option value="Componente">Componente</option>
        <option value="CompSueldo">CompSueldo</option>
        <option value="Concurso">Concurso</option>
        <option value="Cuenta">Cuenta</option>
        <option value="CuentaEmpr">CuentaEmpr</option>
        <option value="CuentaPerl">CuentaPerl</option>
        <option value="CuentaProd">CuentaProd</option>
        <option value="DetalleAsiento">DetalleAsiento</option>
        <option value="Empresa">Empresa</option>
        <option value="EmpresaImg">EmpresaImg</option>
        <option value="EquiAuto">EquiAuto</option>
        <option value="Equipamiento">Equipamiento</option>
        <option value="Existencia">Existencia</option>
        <option value="Formacion">Formacion</option>
        <option value="FormaPago">FormaPago</option>
        <option value="FormPago">FormPago</option>
        <option value="ImpuRete">ImpuRete</option>
        <option value="Localidad">Localidad</option>
        <option value="Mantenimiento">Mantenimiento</option>
        <option value="Marca">Marca</option>
        <option value="MedioArea">MedioArea</option>
        <option value="MedioBanco">MedioBanco</option>
        <option value="MedioCom">MedioCom</option>
        <option value="MedioComImg">MedioComImg</option>
        <option value="MedioEmp">MedioEmp</option>
        <option value="MedioPerl">MedioPerl</option>
        <option value="MedioPers">MedioPers</option>
        <option value="Modelo">Modelo</option>
        <option value="ModeloImg">ModeloImg</option>
        <option value="Modulo">Modulo</option>
        <option value="ModuPlan">ModuPlan</option>
        <option value="ModuUsua">ModuUsua</option>
        <option value="Nivel">Nivel</option>
        <option value="Orden">Orden</option>
        <option value="OrdenAud">OrdenAud</option>
        <option value="OrdenTrab">OrdenTrab</option>
        <option value="PartActi">PartActi</option>
        <option value="PartCta">PartCta</option>
        <option value="Parte">Parte</option>
        <option value="ParteAuto">ParteAuto</option>
        <option value="ParteAutoImg">ParteAutoImg</option>
        <option value="Participante">Participante</option>
        <option value="Partida">Partida</option>
        <option value="Perfil">Perfil</option>
        <option value="PeriEmpr">PeriEmpr</option>
        <option value="Periodo">Periodo</option>
        <option value="Permiso">Permiso</option>
        <option value="Persona">Persona</option>
        <option value="Personal">Personal</option>
        <option value="PersonalImg">PersonalImg</option>
        <option value="PersOrde">PersOrde</option>
        <option value="PersOrdeImg">PersOrdeImg</option>
        <option value="PersRol">PersRol</option>
        <option value="PersRolDet">PersRolDet</option>
        <option value="Plan">Plan</option>
        <option value="PlanCtbl">PlanCtbl</option>
        <option value="Presentacion">Presentacion</option>
        <option value="ProdEmp">ProdEmp</option>
        <option value="ProdOrde">ProdOrde</option>
        <option value="ProdServ">ProdServ</option>
        <option value="ProdTran">ProdTran</option>
        <option value="Producto">Producto</option>
        <option value="ProductoImg">ProductoImg</option>
        <option value="Rol">Rol</option>
        <option value="RolModu">RolModu</option>
        <option value="RolPago">RolPago</option>
        <option value="RolPagoAud">RolPagoAud</option>
        <option value="Servicio">Servicio</option>
        <option value="ServMode">ServMode</option>
        <option value="ServOrden">ServOrden</option>
        <option value="Sesion">Sesion</option>
        <option value="SesionErr">SesionErr</option>
        <option value="Sueldo">Sueldo</option>
        <option value="SuscPago">SuscPago</option>
        <option value="Suscripcion">Suscripcion</option>
        <option value="TablModu">TablModu</option>
        <option value="TipoActi">TipoActi</option>
        <option value="TipoArea">TipoArea</option>
        <option value="TipoDoc">TipoDoc</option>
        <option value="TipoIden">TipoIden</option>
        <option value="TipoPeri">TipoPeri</option>
        <option value="TipoPerm">TipoPerm</option>
        <option value="TipoProd">TipoProd</option>
        <option value="Tipo Tran">TipoTran</option>
        <option value="Titulo">Titulo</option>
        <option value="Transaccion">Transaccion</option>
        <option value="TransaccionAud">TransaccionAud</option>
        <option value="TransPago">TransPago</option>
        <option value="Unidad">Unidad</option>
        <option value="Usuario">Usuario</option>
      </select>
      <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="selectedFileType" disabled v-if="opcion===2">
      <button v-on:click="submitFile()" class="styled-button"><i class="material-icons">upload_file</i> Cargar Archivo</button>
    </td>
        </tr>
      </table>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import api from "@/services/api";

export default {
  components: {
    Layout,
    Footer
  },
  data() {
    return {
      file: '',
      selectedFileType: '' // Variable para almacenar el tipo de archivo seleccionado
    }
  },
  methods: {
    submitFile() {
      if (!this.file || !this.selectedFileType) {
        console.error('Por favor, selecciona un archivo y un tipo de archivo válido.')
        return
      }

      let formData = new FormData();
      formData.append('file', this.file);

      api.post(`/upload${this.selectedFileType.toLowerCase()}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function (response) {
          console.log('SUCCESS!!', response);
        })
        .catch(function (error) {
          console.log('FAILURE!!', error);
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    }
  }
}
</script>
<style>
/* Estilos para el input file */
.file-label {
  display: inline-block;
  padding: 8px 15px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  background-color: #3498db;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.file-input {
  position: absolute;
}

.file-label span {
  display: inline-block;
  padding-right: 10px;
}
/* Estilos para el combo */
.styled-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: center;
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 4px;
  border: 0px solid #ccc;
  outline: none;
  margin-right: 10px;
}

/* Estilos para el botón */
.styled-button {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.styled-button:hover {
  background-color: #45a049;
}
</style>